import { createContext } from 'react';
import type { ErrorState } from '@/core/types/error-types';

interface ErrorContextType {
  errors: ErrorState[];
  showError: (error: ErrorState) => void;
  clearError: (id: string) => void;
  clearAllErrors: () => void;
  currentError: ErrorState | null;
}

export const ErrorContext = createContext<ErrorContextType | undefined>(undefined);
